<template>
    <div v-if="showModal" class="overlay active overlay--auth backdrop-blur pt-10">
      <div class="wrapper-lightbox" style="max-width: 840px;">
        <div class="lightbox">
            <div class="flex justify-content-end">
                <div class="close-modal" @click="close()">
                    <span class="tx-dark-ad">
                        <i class="fas fa-times"></i>
                    </span>
                </div>
            </div>
            <form-wizard
                    stepSize="sm"
                    color="#DBFE54"
                    :title="titleWidzar"
                    :subtitle="subtitleWidzar"
                    nextButtonText="Continuar"
                    backButtonText="Regresar"
                    errorColor="#DBFE54"
                    @on-complete="onComplete"
                    >
                <tab-content title="Información del auto" :before-change="validateStep">
                    <ValidationObserver ref="step1">
                        <car-information :filters="filters"></car-information>
                    </ValidationObserver>
                </tab-content>
                <tab-content :title="step2TabTitle" :before-change="validateStep2">
                    <div v-if="totalSteps == 3" style="width: 100%">
                        <swiper class="swiper" :options="swiperOptionTop" ref="swiperTop" style="width: 96%">
                            <swiper-slide v-for="(car, key) in inventoryMatchedCars" :key="key" class="slide">
                                <thumbnail-car-component v-if="car" :product="car" link-target="_blank" card-img-height="120px" />
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-button-prev swiper-button-prev-featured" slot="button-prev">
                            <span class="tx-30 tx-lightgrey-1"><i class="fas fa-chevron-left"></i></span>
                        </div>
                        <div class="swiper-button-next swiper-button-next-featured" slot="button-next">
                            <span class="tx-30 tx-lightgrey-1"><i class="fas fa-chevron-right"></i></span>
                        </div>
                    </div>
                    <template v-else-if="totalSteps == 2">
                        <ValidationObserver ref="prospectInfoStep2">
                            <user-information :filters="filters"></user-information>
                        </ValidationObserver>
                    </template>
                </tab-content>
                <tab-content title="Información personal" :before-change="validateStep3" v-if="totalSteps == 3">
                    <ValidationObserver ref="prospectInfoStep3">
                        <user-information :filters="filters"></user-information>
                    </ValidationObserver>
                </tab-content>
                <button id="finishbtn" ref="finishbtn" class="wizard-btn" slot="finish">
                    Enviar
                </button>
            </form-wizard>
        </div>
      </div>
    </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

import CarInformation from './CarInformation.vue';
import UserInformation from './UserInformation.vue';

import ThumbnailCarComponent from '../../layout/ThumbnailCarComponent';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

Vue.use(VueSweetalert2);

export default {
    props: ['showModal'],
    components: {
        FormWizard,
        TabContent,
        ValidationObserver,
        CarInformation,
        UserInformation,
        ThumbnailCarComponent,
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            filters: {
                brands: [],
                models: [],
                states: [],
                years: [],
                name: null,
                email: null,
                phone: null
            },
            titleWidzar: '¿Qué auto estás buscando?',
            subtitleWidzar: '',
            message: '',
            inventoryMatchedCars: [],
            swiperOptionTop: {
                lazy: true,
                slidesPerView: 1,
                spaceBetween: 8,
                loop: true,
                // loopFillGroupWithBlank: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    540: {
                        slidesPerView: 1
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 12
                    },
                    1280: {
                        slidesPerView: 3,
                        spaceBetween: 12
                    }
                }
            },
            totalSteps: 1
        }
    },
    computed: {
        step2TabTitle() {
            return this.totalSteps == 2 ? 'Información personal' : 'Autos en Marketplace'  
        },
    },
    methods: {
        close () {
            this.$emit('closeModal')
            this.resetForm();
        },
        validateStep() {
            this.totalSteps = 1
            let isValid = this.$refs.step1.validate()
            
            if (!isValid) return false

            const searchedVehicle = {
                brand: this.filters.brands?.name,
                model: this.filters.models?.name,
                year: this.filters.years,
                state_id: this.filters.states?.value
            }

            axios.post('/client/find-vehicle/inventory', searchedVehicle).then((res) => {
                this.inventoryMatchedCars = res.data
                this.totalSteps = (this.inventoryMatchedCars.length > 0) ? 3 : 2
                if(this.$refs.swiperTop) this.$refs.swiperTop.$swiper.update()
            }).catch(function(error){
                console.error(error)
                return false
            })
            this.titleWidzar = 'Ingresa tu información de contacto';
            this.subtitleWidzar = 'Para avisarte cuando lo encontremos.';
            return isValid;
        },
        validateStep2 () {
            return this.totalSteps == 2 ? this.$refs.prospectInfoStep2.validate() : true
        },
        validateStep3 () {
            return this.$refs.prospectInfoStep3.validate()
        },
        async onComplete (){
            let vm = this;
            vm.loadingAlert()
            document.getElementById("finishbtn").disabled = true;

           await axios.post("/client/find/car", vm.filters)
            .then((response) => {
                vm.message = response.data.message;
                document.getElementById("finishbtn").disabled = false;
                vm.$swal.close()
                vm.close()
                vm.showSuccessAlert(vm.message)
            })
            .catch((error) => {
                document.getElementById("finishbtn").disabled = false;
                vm.message = error.response.data.message;
                vm.$swal.close()
                vm.showErrorAlert(vm.message)
            });
        },
        resetForm () {
            this.filters.brands = [];
            this.filters.models = [];
            this.filters.years = [];
            this.filters.states = [];
            this.filters.name = null;
            this.filters.email = null;
            this.filters.phone = null;
        },
        showErrorAlert(text) {
            // Use sweetalert2
            this.$swal({
                iconHtml: '<img src="../../../../../../assets/images/error_car.png" width="100">',
                title: 'Ha ocurrido un error inesperado.',
                text,
                customClass: {
                icon: 'border-0',
                confirmButton: 'btn-secondary',
                cancelButton: 'btn-outline-primary'
                }
            });
        },
        showSuccessAlert(text) {
            // Use sweetalert2
            let vm = this;
            this.$swal({
                iconHtml: '<img src="../../../../../../assets/images/car.png" width="100">',
                title: '¡Éxito!',
                text,
                customClass: {
                icon: 'border-0',
                confirmButton: 'btn-secondary',
                cancelButton: 'btn-outline-primary'
                }
            }).then((result) => {
                if (result.isConfirmed) {

                }
            });
        },
        loadingAlert() {
            this.$swal({
            title: 'Enviando',
            width: '16em',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                this.$swal.showLoading()
            }
            })
        }
    },
}
</script>
<style lang="css">
.stepTitle {
    color: black !important;
}
.vue-form-wizard .wizard-title {
    color: #000;
    font-weight: 600;
    margin: 0;
    text-align: center;
    font-size: 1.5rem;
}
.vue-form-wizard .category {
    color: #000;
    font-size: 1rem;
}
.swal2-icon {
    border: none;
}
.swal2-title {
    color: #000;
    font-size: 1.5rem;
    font-weight: 600;
}
.swal2-content {
    color: #000;
    font-size: 1.125rem;
}
.swal2-styled.swal2-confirm {
    background-color: #dcfe54;
    color: #000;
    border: 1px solid #dcfe54;
    font-weight: bold;
}
.vue-form-wizard .wizard-btn {
    color: #000 !important;
    letter-spacing: 2px;
    background-color: rgb(219, 254, 84);
    border-color: rgb(219, 254, 84);
}
.vue-form-wizard .wizard-nav-pills>li.active>a .wizard-icon {
    color: #000;
}

.swal2-loader {
    border-color: #000 transparent #000 transparent;
}

.wizard-header > h4.wizard-title {
    font-size: 1.5rem;
}

@media screen and (max-width: 768px) {
    .wizard-header > h4.wizard-title {
        font-size: calc(1vw + 0.9rem);
    }
}

.wizard-nav-pills span.stepTitle {
    font-size: 1.3rem;
}

@media screen and (max-width: 768px) {
    .wizard-nav-pills span.stepTitle {
        font-size: calc(1vw + 0.7rem);
    }
}

@media screen and (max-width: 768px) {
    .card-img {
        height: 180px;
    }
    .swiper-cars .swiper-slide {
        width: 100% !important;
    }
}

@media screen and (max-width: 768px) {
    .wizard-card-footer {
        flex-direction: row !important;
    }
    
    .wizard-card-footer .wizard-btn {
        min-width: 110px !important;
    }
    .wizard-card-footer .wizard-footer-right .wizard-btn {
        margin-top: 0px !important;
    }
}

.swiper-button-prev {
    left: 0;
}
.swiper-button-next {
    right: 0;
}

.overlay--auth {
    padding-top: 100px;
}

@media (max-width: 420px) {
    .overlay--auth {
        padding-top: 111px;
    }
}

.overlay--auth .close-modal {
    margin-right: 0;
    top: 0;
    margin: 2px;
    position: relative;
}
.vue-form-wizard .wizard-header {
    padding: 0 15px 5px 15px;
}

.wrapper-lightbox {
    padding-top: 0;
}

.vue-form-wizard .wizard-tab-content {
    padding: 15px 15px 5px;
}
</style>